<template>
    <transition name="fade">
        <div v-if="showConfirmDialog"
             class="popup"
            >
            <div class="heading d-flex">
                <h5>{{ title }}</h5>
                <i class="material-icons ml-auto"
                   @click.stop="closeConfirmDialog">
                    close
                </i>
            </div>
            <div class="d-flex">
                <button @click.stop="closeConfirmDialog"
                        class="secondary-btn btn-center ml-auto"
                        type="button">{{ cancelButtonLabel }}</button>
                <button @click="confirm"
                        class="danger-btn btn-center"
                        type="button">{{ confirmButtonLabel }}</button>
            </div>
        </div>
    </transition>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import ClickOutside from 'vue-click-outside';

    export default {
        name: 'confirm',
        directives: {ClickOutside},
        computed: {
            ...mapGetters([
                'showConfirmDialog',
                'title',
                'confirmButtonLabel',
                'cancelButtonLabel'
            ])
        },
        methods: {
            ...mapActions([
                'confirm',
                'closeConfirmDialog'
            ])
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/colors";

    .popup {
        font-family: Asap;
        color: $Dark;
        position: fixed;
        top: 200px;
        left: 50%;
        transform: translateX(-50%);
        width: 400px;
        z-index: 8;
        padding: 30px 30px 20px;
        @media screen and (max-width: 568px) {
            width: 380px;
        }
        @media screen and (max-width: 480px) {
            width: 350px;
        }
        @media screen and (max-width: 425px) {
            width: 330px;
        }
        h5 {
            font-size: 18px;
            margin-bottom: 40px;
        }
        i {
            cursor: pointer;
        }
        button {
            width: 100px;
            border-radius: 4px;
            &:last-child {
                margin-left: 20px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/popup/Confirm.vue